import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/Master/PackPrintStruct.css';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { fetchPackingData, fetchSaleInvoiceReg } from '../../../Store/PHPSlice/Packing/PackApis';
import { selectPackingData, selectSaleInvoiceReg } from '../../Selectors/PackSelector/PackingSelector';
import FirmHeaderImg from '../../FieldsComponents/FirmHeaderImg';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import axios from "axios";

const WhInvoiceBill = ({ id, hideButtons, data, url, info, partyId, onDone }) => {
    const printRef = useRef();
    const { Id } = useParams();
    const dispatch = useDispatch();
    const componentRef = useRef();
    const [formData, setFormData] = useState({
        pkId: Id
    })
    const [packInfo, setPackInfo] = useState([]);
    const [isReady, setIsReady] = useState(false);
    const [sending, setSending] = useState(false);
    const [loading, setLoading] = useState(false);
    const [firmUrl, setFirmUrl] = useState('');
    const packData = useSelector(selectSaleInvoiceReg);
    // console.log(packData)
    useEffect(() => {
        dispatch(fetchSaleInvoiceReg(Id));

    }, [Id, dispatch]);

    useEffect(() => {
        if (
            data &&
            Object.keys(data).length > 0 &&
            info &&
            info.length > 0 &&
            partyId
        ) {
            setTimeout(() => {
                setIsReady(true);
            }, 300);
        }
    }, [data, info, partyId]);

    useEffect(() => {
        if (isReady && !sending) {
            generateAndSendPDF();
        }
    }, [isReady]);

    // useEffect(() => {
    //     if (packData?.data) {
    //         const item = packData?.data;
    //         setFormData(prev => ({
    //             ...prev,
    //             billNo: item.billNo,
    //             cgst: item.cgst,
    //             discnt_amt: item.discnt_amt,
    //             discnt_type: item.discnt_type,
    //             discnt_val: item.discnt_val,
    //             dt: item.dt,
    //             firmId: item.firmId,
    //             firmNm: item.firmNm,
    //             firm_tax_sts: item.firm_tax_sts,
    //             freight_ch: item.freight_ch,
    //             gst_val: item.gst_val,
    //             igst: item.igst,
    //             lrdt: item.lrdt,
    //             lrno: item.lrno,
    //             net_amt: item.net_amt,
    //             other_ch: item.other_ch,
    //             parcelqty: item.parcelqty,
    //             partyId: item.partyId,
    //             partyNm: item.partyNm,
    //             party_state: item.party_state,
    //             sgst: item.sgst,
    //             sts: item.sts,
    //             total_amt: item.total_amt,
    //             totqty: item.totqty,
    //             pkMemo: item.pkMemo,
    //             pkdt: item.pkdt,
    //             transptNm: item.transptNm,
    //             shipNm: item.shipNm,
    //             shipadrs: item.shipadrs,
    //             padrs: item.adrs,
    //             contact: item.contact,
    //             pan: item.pan,
    //             gst_no: item.gstNo,
    //         }));
    //     }
    //     if (packData?.Info && packData.Info?.length > 0) {
    //         const info = packData.Info;
    //         setPackInfo(info);
    //     }
    // }, [packData]);

    const terms = [
        { id: 1, terms: "Once Goods Sold Will not be taken back." },
        { id: 2, terms: "Overdue invoices may attract an interest @ 21% P A." },
        { id: 3, terms: "If Payment not received with in 45 days it will be reported under MSME Act." },
        { id: 4, terms: "Our Responsibility ceases on delivering the goods to the carrier/Transportations." }
    ];

    const bankDetails = [
        { id: 1, key: "A/c Holder's Name", value: "HONESTY UNIFORMS(PROP) HUBLI - 2022-23" },
        { id: 2, key: "Bank Name", value: "HDFC OD A/C 50200069699335" },
        { id: 3, key: "A/c No.", value: "50200069699335" },
        { id: 4, key: "Branch & IFS Code", value: "KOPPIKAR ROAD HUBLI & HDFC0001570" },

    ];

    const generateAndSendPDF = async () => {

        // ✅ wait until React finishes rendering the DOM
        await new Promise(resolve => setTimeout(resolve, 400));

        const element = printRef.current;
        if (!element) {
            console.error("Print element not found");
            return;
        }

        const canvas = await html2canvas(element, {
            scale: 2,
            useCORS: true,
            backgroundColor: "#ffffff"
        });

        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        pdf.addImage(imgData, "PNG", 0, 10, pdfWidth, pdfHeight);

        const pdfBlob = pdf.output("blob");

        const formData = new FormData();
        formData.append("file", pdfBlob, "Invoice-bill.pdf");
        formData.append("id", id);
        setLoading(true);
        try {
            const res = await axios.post(
                `https://uniform.smittech.in/api/uniformApi.php?apicall=InvoiceBillSendWhatsApp_API&partyId=${partyId}`,
                formData
            );
            // console.log(res.data)
            if (res?.data?.status === 'success') {
                alert(res.data.msg);
            } else {
                alert("Failed to send WhatsApp PDF");
            }
        } catch (error) {
            console.error("❌ WhatsApp send failed:", error);
        } finally {
            setLoading(false);
            if (onDone) onDone();
        }

    };

    const igstper = parseFloat(data?.gst_val);
    return (

        <Grid item xs={12}>
            <Paper>
                <div ref={printRef} style={{ padding: '1%' }}>
                    {/* Heading */}
                    <img
                        src={url !== "" ? url : firmUrl}
                        alt="Firm Logo"
                        style={{ width: "95%" }}
                    />
                    <h3 className="heading">Invoice Bill</h3>

                    <table className="bill-table">
                        <tbody>
                            <tr>
                                <td className="label">Party</td>
                                <td className="colon">:</td>
                                <td className="value">{data?.partyNm}</td>

                                <td className="label right-col">Bill Date</td>
                                <td className="colon">:</td>
                                <td className="value">{data?.dt}</td>
                            </tr>

                            <tr>
                                <td className="label">Address</td>
                                <td className="colon">:</td>
                                <td className="value">{data?.adrs}</td>

                                <td className="label right-col">Bill No.</td>
                                <td className="colon">:</td>
                                <td className="value">{data?.billNo}</td>
                            </tr>

                            <tr>
                                <td className="label">Contact</td>
                                <td className="colon">:</td>
                                <td className="value">{data?.contact}</td>

                                <td className="label right-col">Delivery Challan No.</td>
                                <td className="colon">:</td>
                                <td className="value">{data?.pkMemo}</td>


                            </tr>

                            <tr>
                                <td className="label">Pan</td>
                                <td className="colon">:</td>
                                <td className="value">{data?.pan}</td>

                                <td className="label right-col">Transport Name</td>
                                <td className="colon">:</td>
                                <td className="value">{data?.transptNm}</td>

                            </tr>

                            <tr>
                                <td className="label">GST</td>
                                <td className="colon">:</td>
                                <td className="value">{data?.gstNo}</td>

                                <td className="label right-col">Parcel Qty</td>
                                <td className="colon">:</td>
                                <td className="value">{data?.parcelqty}</td>


                            </tr>

                            <tr>
                                <td className="label"></td>
                                <td className="colon">:</td>
                                <td className="value"></td>

                                <td className="label right-col">LR No.</td>
                                <td className="colon">:</td>
                                <td className="value">{data?.lrno}</td>


                            </tr>
                            <tr>
                                <td className="label"></td>
                                <td className="colon">:</td>
                                <td className="value"></td>

                                <td className="label right-col">LR Date</td>
                                <td className="colon">:</td>
                                <td className="value">{data?.lrdt}</td>

                            </tr>

                            <tr>
                                <td className="label"></td>
                                <td className="colon">:</td>
                                <td className="value"></td>

                                <td className="label right-col">Ship To Address</td>
                                <td className="colon">:</td>
                                <td className="value">{data?.shipadrs}</td>
                            </tr>
                        </tbody>
                    </table>

                    {/* Main Table */}
                    {info?.length > 0 &&

                        <table className="main-table">
                            <thead>
                                <tr>
                                    <th>SR NO.</th>
                                    <th>PARTICULARS</th>
                                    <th>SIZE</th>
                                    <th>QTY</th>
                                    <th>RATE</th>
                                    <th>AMOUNT</th>
                                </tr>
                            </thead>
                            <tbody>
                                {info?.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item.itemNm}</td>
                                        <td>{item.size}</td>
                                        <td>{item.qty}</td>
                                        <td>{item.rate}</td>
                                        <td>{item.amt}</td>
                                    </tr>
                                ))}
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td><b>Total</b></td>
                                    <td><b>{data?.totqty}</b></td>
                                    <td></td>
                                    <td><b>{data?.total_amt}</b></td>
                                </tr>
                            </tbody>
                        </table>
                    }

                    <table className="main-table">

                        <tbody>

                            {/* <tr>
                                <td>GST(%):</td>
                                <td>{data?.gst_val}</td>
                                <td>Bill Date:</td>
                                <td>{data?.dt}</td>
                            </tr> */}
                            {/* <tr>
                                <td>Total Quantity:</td>
                                <td>{data?.totqty}</td>
                                <td>Total Amount:</td>
                                <td>{data?.total_amt}</td>
                            </tr> */}
                            <tr>
                                <td>IGST({igstper}%):</td>
                                <td>{data?.igst}</td>
                                <td>Freight Charges:</td>
                                <td>{data?.freight_ch}</td>

                                {/* <td>Discount Amount {data?.discnt_val}({data?.discnt_type}):</td>
                                <td>{data?.discnt_amt}</td> */}
                            </tr>
                            <tr>
                                <td>CGST ({igstper / 2}%):</td>
                                <td>{data?.cgst}</td>
                                <td>Printing Charges:</td>
                                <td>{data?.other_ch}</td>

                            </tr>
                            <tr>
                                <td>SGST ({igstper / 2}%):</td>
                                <td>{data?.sgst}</td>
                                <td>Gross Total:</td>
                                <td>{parseFloat(data?.total_amt) + parseFloat(data?.discnt_amt)}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td></td>

                                <td><b>Grand Total:</b></td>
                                <td><b>{data?.net_amt}</b></td>
                            </tr>


                        </tbody>
                    </table>

                    <table className="main-table">
                        <tbody>
                            <tr>
                                <td>
                                    <p>Terms & Conditions.</p>
                                    <ol>
                                        {terms?.map((val) =>
                                            <li key={val.id}>{val.terms}</li>
                                        )}
                                    </ol>
                                </td>
                                <td>
                                    <p>Company's Bank Details</p>

                                    {bankDetails?.map(val => (
                                        <p key={val.id}>
                                            <span>{val.key}</span> : <span style={{ fontWeight: '600' }}>{val.value}</span>
                                        </p>
                                    ))}

                                    <hr style={{ marginTop: '5px', height: '1px', backgroundColor: '#000', border: 'none' }} />

                                    <div className="sign-div">
                                        <p>For HONESTY UNIFORMS(PROP) HUBLI</p>
                                        <br />
                                        <br />
                                        <p>Authorised Signatory</p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* <div style={{ margin: '2% 5%' }}>
                    <ReactToPrint
                        trigger={() => <Button variant="contained" color="primary">Print</Button>}
                        content={() => componentRef.current}
                    />
                </div> */}
            </Paper>
        </Grid>
    );
};

export default WhInvoiceBill;
